import KeenSlider from 'keen-slider'

if (document.querySelector('.sliderSection .keen-slider')) {
	let navWrapper = document.querySelector('.sliderSection .keen-slider-nav')
	let prevArrow = navWrapper.querySelector('.arrows button.prev')
	let nextArrow = navWrapper.querySelector('.arrows button.next')

	var slider = new KeenSlider(
		'.sliderSection .keen-slider',
		{
			loop: false,
			slides: {
				perView: 1,
				spacing: 16,
			},
			breakpoints: {
				'(min-width: 767px)': {
					slides: {
						perView: 1.2,
						spacing: 24,
					},
				},
				'(min-width: 1500px)': {
					slides: {
						perView: 1.2,
						spacing: 40,
					},
				},
			},
		},
		[
			slider => {
				function updateClasses() {
					var slide = slider.track.details.rel
					slide === 0
						? prevArrow.classList.add('arrow--disabled')
						: prevArrow.classList.remove('arrow--disabled')
					slide === slider.track.details.slides.length - 1
						? nextArrow.classList.add('arrow--disabled')
						: nextArrow.classList.remove('arrow--disabled')
				}

				prevArrow.addEventListener('click', () => {
					slider.prev()
				})

				nextArrow.addEventListener('click', () => {
					slider.next()
				})

				slider.on('created', () => {
					updateClasses()
				})
				slider.on('slideChanged', () => {
					updateClasses()
				})
				slider.on('optionsChanged', () => {
					updateClasses()
				})
			},
		],
	)

	setTimeout(() => {
		slider.update()
	}, 1000)
}
